import React from 'react'
import { Link } from 'react-router-dom'
import axios from '~/data/http/axios'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import Column from '~/Common-Objects/Grids/Column/Column'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icons from '~/Common-Objects/UI/Icons/index'
import PagingBlock from '~/Common-Objects/Tables/DataTablePaging/DataTablePaging'
import Row from '~/Common-Objects/Grids/Row/Row'
import Score from '~/Common-Objects/UI/Score'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SnackBar from '~/Common-Objects/UI/Notifications/SnackBar/SnackBar'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import queryString from 'query-string'
import axios2 from 'axios'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import NumberFunctions from '~/Classes/numberFormatFunctions'
import PermissionChecker from '~/Classes/permissions'
import { getUserSettings, setUserSettings } from '~/Classes/userSettings.jsx'
import i18n from '~/i18n'
import IncGoTickSubs from './incGoTickSubs.jsx'
import BulkEdit from './bulkEdit'
import GroupAutomate from './automate.jsx'
import { alterSiteDrawer } from '../../../../data/actions/siteActions.jsx'
import ColumnSelect from '~/Common-Objects/UI/ColumnSelect'

const SELECTED_FIELDS_LIMIT = 15

//CONNECT TO STORE
@connect((store) => {
    return {
        user: store.user,
        browser: store.browser,
        permissionStore: store.permission,
        accountMaster: store.accountMaster,
        siteMaster: store.siteMaster
    }
})
export default class GroupSubscribersComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            group: undefined,
            loadingData: 1,
            groupID: 0,
            subscribers: [],
            totalGroupSubscribers: 0,
            totalGroupSubscribersFiltered: undefined,
            customFields: [],
            currentPage: 0,
            sortDirection: 'desc',
            sortColumn: 'createdAt',
            pageSize: 15,
            totalSubsInGroup: 0,
            searchText: '',
            deleteConfirm: false,
            selectedFields: [],
            selectedSubscriber: 0,
            startRecord: 0,
            retry: 0,
            segmentsLoadingStats: true,
            segmentsData: [],
            blacklistSegment: undefined,
            segmentId: undefined,
            status: '',
            overrideCount: null,
            blacklistFilter: 0,
            drawerOptions: {
                isOpen: false,
                innerPopOpen: false,
                toastDelete: false,
                toastCopy: false,
                toastStatus: false,
                toastMove: false,
                tickedTot: 0,
                tickedData: []
            },
            isBlacklist: false,
            fieldsFilter: '',
            systemFields: [
                { fieldName: 'score', fieldDesc: i18n.t('score') },
                { fieldName: 'status', fieldDesc: i18n.t('status') },
                { fieldName: 'addedToGroup', fieldDesc: i18n.t('addedToGroup') },
                { fieldName: 'createdAt', fieldDesc: i18n.t('created') },
                { fieldName: 'updatedAt', fieldDesc: i18n.t('lastUpdated') },
                { fieldName: 'lastSendDate', fieldDesc: i18n.t('lastSent') },
                { fieldName: 'lastOpened', fieldDesc: i18n.t('lastOpened') },
                { fieldName: 'lastClicked', fieldDesc: i18n.t('lastClicked') },
                { fieldName: 'lastBounced', fieldDesc: i18n.t('lastBounced') },
                { fieldName: 'tags', fieldDesc: i18n.t('tags') },
                { fieldName: 'disableOpens', fieldDesc: i18n.t('disableOpens') }
                // { fieldName: 'disableClicks', fieldDesc: i18n.t('disableClicks') }
            ],
            selectedSystemFields: [],
            tags: [],
            linkTags: [],
            selectedTags: [],
            selectedLinkTags: [],
            settings: null,
            smsFieldId: this.props.accountMaster.accountMaster.options?.smsDefaultField
        }

        this.CancelToken = axios2.CancelToken
        this.source = this.CancelToken.source()

        this.retryTimer = null

        this.tableDataGetter = this.tableDataGetter.bind(this)
        this.changePage = this.changePage.bind(this)
        this.goSearchText = this.goSearchText.bind(this)
        this.checkAll = this.checkAll.bind(this)
        this.changeSearchText = this.changeSearchText.bind(this)
        this.mapDataToState = this.mapDataToState.bind(this)
        this.checkBoxes = this.checkBoxes.bind(this)
        this.countChecked = this.countChecked.bind(this)
        this.checkAll = this.checkAll.bind(this)
        this.searchKeyPress = this.searchKeyPress.bind(this)
        this.goAddSubsciberPage = this.goAddSubsciberPage.bind(this)
        this.changePageSize = this.changePageSize.bind(this)
        this.getCustomFields = this.getCustomFields.bind(this)
        this.selectFields = this.selectFields.bind(this)
        this.reloadAfterTickedAndChanged = this.reloadAfterTickedAndChanged.bind(this)
        this.getGroup = this.getGroup.bind(this)
        this.getSegments = this.getSegments.bind(this)
        this.changeSegment = this.changeSegment.bind(this)
        this.bulkEdit = this.bulkEdit.bind(this)
        this.filterFields = this.filterFields.bind(this)
        this.toggleAllFields = this.toggleAllFields.bind(this)
        this.getTags = this.getTags.bind(this)
        this.getLinkTags = this.getLinkTags.bind(this)
        this.selectTags = this.selectTags.bind(this)
        this.changeSelectedFields = this.changeSelectedFields.bind(this)
    }
    //component state
    componentDidMount() {
        var groupID = this.props.match.params.groupID
        var isBlacklist = true
        if (this.props.accountMaster.accountMaster.blackListGroupId != groupID) {
            isBlacklist = false
        }
        //see if we have write access to the subscribers
        var writeAccess = PermissionChecker('subscribers', this.props.permissionStore.permissions, 'write')

        getUserSettings().then((s) => {
            if (!s.subscribers) s.subscribers = {}
            let save = false
            if (!s.subscribers.limit && this.props.accountMaster.tableLimits?.subscribers) {
                save = true
                s.subscribers.limit = this.props.accountMaster.tableLimits.subscribers
            }
            if (!s.subscribers.systemFields && this.props.accountMaster.systemFields?.[this.props.accountMaster.id]) {
                save = true
                s.subscribers.systemFields = this.props.accountMaster.systemFields[this.props.accountMaster.id].map(
                    (f) => f.fieldName
                )
            }
            if (!s.subscribers.fields && this.props.accountMaster.fields?.[this.props.accountMaster.id]) {
                save = true
                s.subscribers.fields = this.props.accountMaster.fields[this.props.accountMaster.id]
            }
            if (save) setUserSettings(s).catch(console.log)
            const obj = {
                settings: s,
                selectedSystemFields: s.subscribers.systemFields
                    ? this.state.systemFields
                          .filter((f) =>
                              s.subscribers.systemFields.some((s) => {
                                  if (typeof s === 'string') {
                                      return s === f.fieldName
                                  } else {
                                      return s.fieldName === f.fieldName
                                  }
                              })
                          )
                          .map((f) => f.fieldName)
                    : [...this.state.systemFields.map((f) => f.fieldName)],
                pageSize: s.subscribers.limit || 15,
                groupID,
                isBlacklist,
                writeAccess
            }
            const query = queryString.parse(location.search)
            if (query.sortColumn) obj.sortColumn = query.sortColumn
            if (query.sortDirection) obj.sortDirection = query.sortDirection
            if (query.searchText) obj.searchText = query.searchText
            if (query.segmentId) obj.segmentId = query.segmentId
            if (query.status) obj.status = query.status
            if (parseInt(query.recordLimit)) obj.pageSize = parseInt(query.recordLimit)
            if (parseInt(query.pageSize)) obj.pageSize = parseInt(query.pageSize)
            if (parseInt(query.startRecord)) obj.currentPage = parseInt(query.startRecord) / obj.pageSize

            if (query.tags) {
                if (Array.isArray(query.tags)) {
                    obj.selectedTags = query.tags
                } else {
                    obj.selectedTags = [query.tags]
                }
            }

            if (query.linkTags) {
                if (Array.isArray(query.linkTags)) {
                    obj.selectedLinkTags = query.linkTags
                } else {
                    obj.selectedLinkTags = [query.linkTags]
                }
            }

            this.setState(obj, () => this.getCustomFields())
        })
    }

    componentDidUpdate() {
        if (!this.props.siteMaster.siteDrawer) return
        if (this.props.siteMaster.siteDrawer.isOpen !== this.state.editing) {
            this.setState({
                editing: this.props.siteMaster.siteDrawer.isOpen
            })
        }
    }

    componentWillUnmount() {
        this.source.cancel('I cancelled this')
        this.source = this.CancelToken.source()

        if (this.timer) clearTimeout(this.timer)
        if (this.refreshTimer) clearInterval(this.refreshTimer)
        if (this.retryTimer) clearTimeout(this.retryTimer)
    }

    async getSegments() {
        let q = '?'
        if (this.state.isBlacklist) {
            q += 'name=Blacklisted'
        }
        const response = await axios.get('/segment' + q)
        let segments = response.data.Segments

        segments = segments.map((seg) => {
            seg.label = seg.name
            if (seg.readOnly || seg.readOnly == '1') {
                if (seg.label == 'Active') seg.label = i18n.t('Active')
                if (seg.label == 'In-Active') seg.label = i18n.t('In-Active')
                if (seg.label == 'Unsubscribed') seg.label = i18n.t('Unsubscribed')
                if (seg.label == 'Bounced') seg.label = i18n.t('Bounced')
                if (seg.label == 'Blacklisted') {
                    seg.label = i18n.t('Blacklisted')
                }
            }
            return seg
        })

        this.setState({
            segmentsData: segments.filter((s) => !isNaN(s.id) || s.id === 'SMS'),
            blacklistSegment: segments.find((s) => s.name === 'Blacklisted'),
            isLoadingSegments: false
        })
    }
    async getTags() {
        let tags = await axios.get(`/tags?tagType=0`)
        tags = tags.data.map((t) => {
            return {
                label: t.tagName,
                value: t.id,
                id: t.id,
                Application: t.Application,
                ApplicationId: t.ApplicationId,
                tagType: t.tagType
            }
        })
        let adTags = await axios.get(`/tags?tagType=3`)
        tags = tags.concat(
            adTags.data.map((t) => {
                return {
                    label: t.tagName,
                    value: t.id,
                    id: t.id,
                    Application: t.Application,
                    ApplicationId: t.ApplicationId,
                    tagType: t.tagType
                }
            })
        )

        tags = tags.sort((a, b) => {
            // sort by name
            return a.label.localeCompare(b.label)
        })

        tags.forEach((tag) => {
            const selected = this.firstLoad ? this.state.selectedTags.some((s) => parseInt(s) === tag.value) : false
            tag.selected = selected
        })
        this.setState({ tags: tags }, this.getLinkTags)
    }

    getLinkTags() {
        axios.get(`/tags?tagType=1`).then((data) => {
            this.setState(
                {
                    linkTags: data.data
                        .map((t) => {
                            const selected = this.firstLoad
                                ? this.state.selectedLinkTags.some((s) => parseInt(s) === t.id)
                                : false
                            return {
                                id: t.id,
                                label: t.tagName,
                                value: t.id,
                                selected
                            }
                        })
                        .sort((a, b) => {
                            // sort by name
                            return a.label.localeCompare(b.label)
                        })
                },
                this.getGroup
            )
        })
    }
    getGroup() {
        axios
            .get('/group/' + this.state.groupID, {
                cancelToken: this.source.token
            })
            .then((response) => {
                if (response.data.Group.sync) {
                    this.timer = setTimeout(() => this.getGroup(refresh), 5000)
                } else {
                    clearTimeout(this.timer)
                    clearInterval(this.refreshTimer)
                }
                this.setState(
                    {
                        totalSubsInGroup: response.data.Group.totalSubscribers,
                        totalGroupSubscribers: response.data.Group.totalSubscribers,
                        group: response.data.Group
                    },
                    () => {
                        this.tableDataGetter()
                    }
                )
            })
    }
    goAddSubsciberPage() {
        this.props.history.push('/cp/groups/' + this.state.groupID + '/add/')
    }
    searchKeyPress(event) {
        if (event.key === 'Enter') {
            this.goSearchText()
        }
    }
    //checkBox Checking
    checkAll(event, forcedUntick) {
        var isChecked

        if (event) {
            isChecked = event.target.checked
        }
        if (forcedUntick && forcedUntick === true) {
            isChecked = false
        }
        //create a copy of the array with object.extend
        var newState = Object.assign([], this.state.subscribers)
        for (var x in Object.keys(newState)) {
            var thisProp = newState[x]
            var checkBox = React.cloneElement(thisProp.checkBox.value, { checked: isChecked })
            var headerValue = React.cloneElement(thisProp.checkBox.headerValue, { checked: isChecked })
            thisProp.checkBox.isChecked = isChecked
            thisProp.checkBox.value = checkBox
            thisProp.checkBox.headerValue = headerValue
            newState[x] = thisProp
        }
        //write it back to state
        this.setState(
            {
                subscribers: newState
            },
            this.countChecked
        )
    }
    countChecked() {
        var tickedSubs = this.state.subscribers.filter((sub) => sub.checkBox.isChecked)

        var isOpen = false
        var drawerContent = <div></div>
        if (tickedSubs.length > 0) {
            isOpen = true
            drawerContent = (
                <IncGoTickSubs
                    checkAll={this.checkAll}
                    groupId={this.state.groupID}
                    subscribers={this.state.subscribers}
                    totTicked={tickedSubs.length}
                    reloadAfterTickedAndChanged={this.reloadAfterTickedAndChanged}
                    isBlackList={this.state.isBlacklist}
                />
            )
        }
        this.props.dispatch(siteMaster.alterSiteDrawer(isOpen, false, 'right', drawerContent, true, 400))
    }
    checkBoxes(event) {
        var thisDataID = event.target.name.replace('sub', '')
        var isChecked = event.target.checked
        var newState = this.state.subscribers
        var checkBox = React.cloneElement(newState[thisDataID].checkBox.value, { checked: isChecked })
        newState[thisDataID].checkBox.isChecked = isChecked
        newState[thisDataID].checkBox.value = checkBox
        this.setState(
            {
                subscribers: newState
            },
            this.countChecked
        )
    }
    reloadAfterTickedAndChanged(changedExpected) {
        this.checkAll(null, true)
        if (this.refreshTimer) clearInterval(this.refreshTimer)
        this.refreshTimer = setInterval(() => this.tableDataGetter(), 5000)
        this.tableDataGetter()
    }
    //search options
    changeSearchText(event) {
        this.setState(
            {
                searchText: event.target.value,
                page: 0
            },
            () => {
                if (this.timer) clearTimeout(this.timer)
                this.timer = setTimeout(this.goSearchText, 500)
            }
        )
    }
    goSearchText() {
        this.changePage(0, null, null, null, null)
    }
    //paging
    changePageSize(pageSize) {
        const settings = this.state.settings
        settings.subscribers.limit = pageSize
        setUserSettings(settings).catch(console.log)
        this.setState({ settings, pageSize: pageSize, currentPage: 0 }, this.changePage)
    }
    changePage(currentPage, sortDirection, sortColumn, pageSize, searchText) {
        if (!sortDirection) {
            sortDirection = this.state.sortDirection
        }
        if (!sortColumn) {
            sortColumn = this.state.sortColumn
        }
        if (!pageSize) {
            pageSize = this.state.pageSize
        }
        if (!currentPage && currentPage != '0') {
            currentPage = this.state.currentPage
        }
        if (!searchText) {
            searchText = this.state.searchText
        }

        var startRecord = currentPage * pageSize

        this.setState(
            {
                sortColumn: sortColumn,
                sortDirection: sortDirection,
                pageSize: pageSize,
                currentPage: currentPage,
                searchText: searchText,
                startRecord: startRecord
            },
            () => this.tableDataGetter(sortColumn, sortDirection, startRecord, pageSize, searchText)
        )
    }

    changeSelectedFields(arr) {
        this.setState(
            {
                selectedFields: arr.filter((a) => !isNaN(a)),
                selectedSystemFields: arr.filter((a) => isNaN(a))
            },
            () => {
                const settings = this.state.settings
                settings.subscribers.systemFields = this.state.selectedSystemFields
                settings.subscribers.fields = this.state.selectedFields
                setUserSettings(settings).catch(() => {})
                this.tableDataGetter()
            }
        )
    }

    //subsriber data stuff
    tableDataGetter(sortColumn, sortDirection, startRecord, pageSize, searchText) {
        if (this.state.isLoading) {
            this.source.cancel('I cancelled this')
            this.source = this.CancelToken.source()
        }

        var customFieldArray = []
        this.state.customFields.map((field) => {
            if (field.selected) {
                customFieldArray.push(field.id)
            }
        })

        if (!sortColumn) {
            sortColumn = this.state.sortColumn
        }
        if (!sortDirection) {
            sortDirection = this.state.sortDirection
        }
        if (!startRecord) {
            startRecord = this.state.startRecord
        }
        if (!pageSize) {
            pageSize = this.state.pageSize
        }
        if (!searchText) {
            searchText = this.state.searchText
        }

        var queryStr =
            '?sortColumn=' +
            sortColumn +
            '&sortOrder=' +
            sortDirection +
            '&startRecord=' +
            startRecord +
            '&recordLimit=' +
            pageSize +
            '&searchText=' +
            encodeURIComponent(searchText) +
            (this.state.status ? `&status=${this.state.status}` : '') +
            (this.state.segmentId ? '&segmentId=' + this.state.segmentId : '')

        let selectedTags = this.state.selectedTags
        if (selectedTags.length) {
            queryStr += `&tags=${selectedTags.join(',')}`
        }
        let selectedLinkTags = this.state.selectedLinkTags
        if (this.state.selectedLinkTags.length) {
            queryStr += `&linkTags=${selectedLinkTags.join(',')}`
        }
        if (this.state.linkTags) {
            let selectedLinkTags = this.state.linkTags.filter((t) => t.selected)
            if (selectedLinkTags.length) {
                queryStr += `&linkTags=${selectedLinkTags.map((tag) => tag.id).join(',')}`
            }
        }
        if (history.pushState) {
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + queryStr
            window.history.pushState({ path: newurl }, '', newurl)
        }

        queryStr += `&fields=${JSON.stringify(
            this.state.selectedFields.slice(0, SELECTED_FIELDS_LIMIT - this.state.selectedSystemFields.length)
        )}`

        if (this.state.smsFieldId && this.state.segmentId === 'SMS') {
            queryStr += '&smsFieldId=' + this.state.smsFieldId
        }

        if (this.state.isBlacklist && this.state.blacklistFilter > 0) {
            queryStr += `&blacklistFilter=${this.state.blacklistFilter}`
        }

        this.setState({
            isLoading: true,
            totalGroupSubscribersFiltered: undefined
        })

        var promise
        if (this.state.isBlacklist) {
            promise = axios.get(
                '/segment/' + this.state.blacklistSegment?.id + '/results' + queryStr + '&count=false',
                {
                    cancelToken: this.source.token
                }
            )
        } else {
            promise = axios.get('/group/' + this.props.match.params.groupID + '/subscriber' + queryStr, {
                cancelToken: this.source.token
            })
        }

        promise
            .then((res) => {
                //map the subscribers data to data we can send to the table component.
                this.mapDataToState(res.data.Subscribers, res.data.count, res.data.retry)
                if (res.data.retry) {
                    this.retryTimer = setTimeout(this.tableDataGetter, 1500)
                }
            })
            .catch(console.log)
    }
    mapDataToState(theData, count, retry) {
        const totalTags = theData.reduce((a, b) => a + (b.Tags?.length || 0), 0)

        var theSubscribersData = theData.map((thisLine, index) => {
            var finalStatus = i18n.t('Active')
            var finalStatusCol = 'square-chip-green'
            if (!thisLine.active) {
                finalStatusCol = 'square-chip-orange'
                finalStatus = i18n.t('In-Active')
            }
            if (thisLine.unsubscribed) {
                finalStatusCol = 'square-chip-red'
                finalStatus = i18n.t('Unsubscribed')
            }
            if (thisLine.bounced) {
                finalStatusCol = 'square-chip-purple'
                finalStatus = i18n.t('Bounced')
            }
            if (thisLine.blackListed) {
                finalStatus = i18n.t('Blacklisted')
                finalStatusCol = 'square-chip-black'
            }

            if (!thisLine.score) thisLine.score = 0

            let selectedTags = []

            if (thisLine.Tags && thisLine.Tags.length && this.state.tags.length) {
                selectedTags = thisLine.Tags
            }

            const important = thisLine.customFields
                .filter((f) => f.important)
                .sort((a, b) => {
                    return a.fieldDesc.localeCompare(b.fieldDesc)
                })

            var line = {
                rowDeleted: { value: false, order: -1 },
                checkBox: {
                    headerValue: (
                        <CheckBox
                            outerClassName='no-marg'
                            checked={false}
                            onChange={(event) => {
                                this.checkAll(event)
                            }}
                        />
                    ),
                    orderBy: false,
                    value: (
                        <CheckBox
                            outerClassName='no-marg'
                            checked={false}
                            onChange={(event) => {
                                this.checkBoxes(event)
                            }}
                            name={'sub' + index}
                        />
                    ),
                    isCheckBox: true,
                    width: 30,
                    isChecked: false,
                    order: -3
                },
                gravatar: {
                    headerValue: '',
                    value: (
                        <Avatar
                            style={{
                                height: 'auto',
                                width: '100%',
                                maxWidth: '40px',
                                maxHeight: '40px',
                                marginRight: '10px'
                            }}
                            src={thisLine.accountImage}
                        />
                    ),
                    width: 50,
                    order: -2
                },
                emailAddress: {
                    headerValue: i18n.t('emailAddress'),
                    value: (
                        <div>
                            <Link
                                style={{ textDecoration: 'none' }}
                                to={'/cp/subscriber/' + (thisLine.subscriberId || thisLine.id)}
                            >
                                {thisLine.emailAddress}
                            </Link>
                            {thisLine.Organisation ? (
                                <div>
                                    <a
                                        className='text-sml text-grey'
                                        onClick={() =>
                                            this.props.history.push(
                                                '/cp/subscribers/organisations/' + thisLine.Organisation.id
                                            )
                                        }
                                    >
                                        {thisLine.Organisation.name}
                                    </a>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    ),
                    orderBy: true,
                    emailText: thisLine.emailAddress,
                    order: -1
                },
                score: {
                    headerValue: i18n.t('score'),
                    value: <Score score={thisLine.score} />,
                    orderBy: true,
                    order: 1 + important.length,
                    width: 100
                },
                status: {
                    headerValue: i18n.t('status'),
                    value: (
                        <SquareChip
                            className={finalStatusCol + ' small-icon'}
                            iconLeft={<Icons icon='circle' />}
                        >
                            {finalStatus}
                        </SquareChip>
                    ),
                    orderBy: false,
                    order: 2 + important.length,
                    align: 'center'
                },
                createdAt: {
                    headerValue: i18n.t('created'),
                    value: DateTimeFunctions.formatDateTime(thisLine.createdAt, '2'),
                    orderBy: true,
                    order: 3 + important.length
                },
                addedToGroup: {
                    headerValue: i18n.t('addedToGroup'),
                    value: DateTimeFunctions.formatDateTime(thisLine.addedToGroup, '2'),
                    order: 4 + important.length,
                    orderBy: true
                },
                updatedAt: {
                    headerValue: i18n.t('lastUpdated'),
                    value: DateTimeFunctions.formatDateTime(
                        thisLine.lastUpdated || thisLine.addedToGroup || thisLine.updatedAt,
                        '2'
                    ),
                    orderBy: true,
                    width: 200,
                    order: 5 + important.length
                },
                lastSendDate: {
                    headerValue: i18n.t('lastSent'),
                    value: thisLine.lastSendDate ? (
                        DateTimeFunctions.formatDateTime(thisLine.lastSendDate)
                    ) : (
                        <span className='text-light-grey'>{i18n.t('never')}</span>
                    ),
                    orderBy: true,
                    order: 6 + important.length
                },
                lastOpened: {
                    headerValue: i18n.t('lastOpened'),
                    value: thisLine.lastOpened ? (
                        DateTimeFunctions.formatDateTime(thisLine.lastOpened)
                    ) : (
                        <span className='text-light-grey'>{i18n.t('never')}</span>
                    ),
                    orderBy: true,
                    order: 7 + important.length
                },
                lastClicked: {
                    headerValue: i18n.t('lastClicked'),
                    value: thisLine.lastClicked ? (
                        DateTimeFunctions.formatDateTime(thisLine.lastClicked)
                    ) : (
                        <span className='text-light-grey'>{i18n.t('never')}</span>
                    ),
                    orderBy: true,
                    order: 8 + important.length
                },
                lastBounced: {
                    headerValue: i18n.t('lastBounced'),
                    value: thisLine.lastBounced ? (
                        DateTimeFunctions.formatDateTime(thisLine.lastBounced)
                    ) : (
                        <span className='text-light-grey'>{i18n.t('never')}</span>
                    ),
                    orderBy: true,
                    order: 9 + important.length
                },
                tags: {
                    headerValue: i18n.t('tags'),
                    value: selectedTags.map((tag) => {
                        let icon = ''
                        let text = ''
                        let color = ''
                        if (tag.tagType === 0) {
                            icon = 'person'
                            text = 'Contact Tag'
                            color = 'square-chip-primary'
                        }
                        if (tag.tagType === 1) {
                            icon = 'link'
                            text = 'Link Tag'
                            color = 'square-chip-secondary'
                        }
                        if (totalTags > 30) {
                            return (
                                <SquareChip
                                    iconLeft={
                                        <Icons
                                            icon={icon}
                                            color='white'
                                            style={{ height: 10, width: 10 }}
                                            alt={text}
                                            title={text}
                                        />
                                    }
                                    key={thisLine.id + '_tag_' + tag.id}
                                    className={'square-chip-tag ' + color}
                                >
                                    {tag.tagName || tag}
                                </SquareChip>
                            )
                        } else {
                            return (
                                <SquareChip
                                    iconLeft={
                                        <Icons
                                            icon={icon}
                                            color='white'
                                            style={{ height: 10, width: 10 }}
                                            data-tooltip-content={text}
                                            data-tooltip-id={thisLine.id + '_tag_' + tag.id}
                                        />
                                    }
                                    key={thisLine.id + '_tag_' + tag.id}
                                    className={'square-chip-tag ' + color}
                                >
                                    {tag.tagName || tag}
                                </SquareChip>
                            )
                        }
                    }),
                    orderBy: false,
                    order: 10 + important.length
                },
                disableOpens: {
                    headerValue: i18n.t('disableOpens'),
                    value: thisLine.disableOpens ? i18n.t('yes') : i18n.t('no'),
                    orderBy: false,
                    order: 11 + important.length
                }
                // disableClicks: {
                //     headerValue: i18n.t('disableClicks'),
                //     value: row.disableClicks ? i18n.t('yes') : i18n.t('no'),
                //     orderBy: true,
                //     order: 12 + important.length
                // }
            }

            if (!PermissionChecker('subscribers', this.props.permissionStore.permissions, 'write')) {
                delete line.checkBox
            }

            this.state.systemFields.forEach((field) => {
                if (!this.state.selectedSystemFields.some((f) => f === field.fieldName)) {
                    delete line[field.fieldName]
                }
            })

            important
                .concat(
                    thisLine.customFields
                        .filter((f) => !f.important)
                        .sort((a, b) => {
                            return a.fieldDesc.localeCompare(b.fieldDesc)
                        })
                )
                .forEach((field, index) => {
                    var value = ''
                    var found = thisLine.customFields.find((f) => f.id === field.id)
                    if (found) {
                        if (!Array.isArray(found.value)) {
                            found.value = [found.value]
                        }
                        found.value.forEach((val, i) => {
                            if (field.fieldType == 'DATE') {
                                found.value[i] = val ? DateTimeFunctions.formatDateTime(val, '2') : ''
                            } else if (field.fieldType == 'NUMBER') {
                                found.value[i] = NumberFunctions.formatNumber(val)
                            } else if (field.fieldType == 'BOOLEAN') {
                                found.value[i] = val && (val == true || val == 1) ? 'Yes' : 'No'
                            } else if (
                                (field.fieldType == 'SELECT' || field.fieldType == 'MULTISELECT') &&
                                field.options &&
                                field.options.length
                            ) {
                                var option = field.options.find((o) => o.value == val)
                                found.value[i] = option ? option.label : val
                            }
                        })
                        value = found.value.join(', ')
                    }
                    line['' + field.id + ''] = {
                        headerValue: field.fieldDesc,
                        value,
                        orderBy: true,
                        width: 200,
                        order: field.important ? index : index + this.state.systemFields.length + 6
                    }
                })

            var options = {
                subscriberData: {
                    id: thisLine.subscriberId ? thisLine.subscriberId : thisLine.id,
                    order: 100
                }
            }
            //adds multiple objects together to create on object.
            return Object.assign(line, options)
        })

        this.setState({
            subscribers: theSubscribersData,
            totalGroupSubscribersFiltered: count !== undefined ? count : this.state.totalGroupSubscribers,
            loadingData: 0,
            isLoading: retry,
            retry: retry ? this.state.retry + 1 : 0
        })
    }
    //Fields
    getCustomFields() {
        axios
            .get('/customfield')
            .then((res) => {
                var customFields = res.data.CustomFields.filter(
                    (cf) => cf.entityType === 1 || cf.entityType === 3 || !cf.entityType
                )
                customFields.forEach((f) => {
                    var found = false
                    if (this.state.settings.subscribers.fields) {
                        found = this.state.settings.subscribers.fields.some((r) => r == f.id)
                    }
                    f.selected = found
                })
                this.setState(
                    {
                        customFields,
                        selectedFields: customFields.filter((f) => f.selected).map((f) => f.id)
                    },
                    () => {
                        this.getTags()
                        this.getSegments()
                    }
                )
            })
            .catch(() => {
                this.getSegments()
                this.tableDataGetter()
            })
    }
    selectFields(field) {
        var self = this

        if (!field.id) {
            // its a system field
            let selectedSystemFields = this.state.selectedSystemFields
            const index = selectedSystemFields.findIndex((f) => f.fieldName === field.fieldName)
            if (index > -1) {
                selectedSystemFields.splice(index, 1)
            } else {
                selectedSystemFields.push(field)
            }
            const settings = this.state.settings
            settings.subscribers.systemFields = selectedSystemFields.map((f) => f.fieldName)
            setUserSettings(settings).catch(() => {})
            this.setState({ selectedSystemFields, settings }, this.changePage)
        } else {
            var newFields = this.state.customFields
            newFields.forEach((x) => {
                if (x.id == field.id) {
                    x.selected = !x.selected
                }
            })

            const settings = this.state.settings
            settings.subscribers.fields = newFields.filter((f) => f.selected).map((f) => f.id)
            setUserSettings(settings).catch(console.log)
            this.setState({ customfields: newFields, settings }, this.changePage)
        }
    }

    changeSegment(segmentId) {
        this.setState(
            {
                segmentId: segmentId,
                page: 0
            },
            () => this.tableDataGetter()
        )
    }

    selectTags(event) {
        const value = event.target.value
        const tagId = parseInt(value.substring(2))
        if (value.indexOf('1_') === 0) {
            let index = this.state.selectedTags.indexOf(tagId)
            if (index > -1) {
                let selectedTags = [...this.state.selectedTags]
                selectedTags.splice(index, 1)
                this.setState({ selectedTags }, () => this.tableDataGetter())
            } else {
                let selectedTags = [...this.state.selectedTags, tagId]
                this.setState({ selectedTags }, () => this.tableDataGetter())
            }
        } else if (value.indexOf('2_') === 0) {
            let index = this.state.selectedLinkTags.indexOf(tagId)
            if (index > -1) {
                let selectedLinkTags = [...this.state.selectedLinkTags]
                selectedLinkTags.splice(index, 1)
                this.setState({ selectedLinkTags }, () => this.tableDataGetter())
            } else {
                let selectedLinkTags = [...this.state.selectedLinkTags, tagId]
                this.setState({ selectedLinkTags }, () => this.tableDataGetter())
            }
        }
    }

    bulkEdit() {
        var segment = parseInt(this.state.segmentId)
            ? this.state.segmentsData.find((s) => s.id == this.state.segmentId)
            : this.state.segmentId
        var drawerContent = (
            <BulkEdit
                id={this.state.groupID}
                selectedTags={this.state.tags.filter((t) => t.selected)}
                selectedLinkTags={this.state.linkTags.filter((t) => t.selected)}
                searchText={this.state.searchText}
                segment={segment}
                status={this.state.status}
                isBlackList={this.state.isBlacklist ? this.state.segmentId : false}
                segmentTotal={this.state.totalGroupSubscribersFiltered}
                totalSubs={this.state.totalSubsInGroup}
                smsFieldId={this.state.smsFieldId}
                close={(rebuild) => {
                    if (rebuild) {
                        this.reloadAfterTickedAndChanged()
                    }
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null, false))
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, 400))
    }
    filterFields(text) {
        this.setState({
            fieldsFilter: text.toLowerCase()
        })
    }
    toggleAllFields(select) {
        var self = this
        var newFields = this.state.customFields

        newFields.forEach((x) => {
            x.selected = select
        })

        const selectedSystemFields = select ? [...this.state.systemFields] : []
        const settings = this.state.settings
        settings.subscribers.fields = newFields.map((f) => f.if)
        settings.subscribers.systemFields = this.state.systemFields.map((f) => f.fieldName)
        setUserSettings(settings).catch(console.log)

        this.setState({ customfields: newFields, selectedSystemFields }, self.changePage)
    }

    getFields() {
        if (this.state.fieldsFilter) {
            return this.state.systemFields
                .concat(this.state.customFields)
                .filter((f) => f.fieldDesc.toLowerCase().indexOf(this.state.fieldsFilter) > -1)
        } else {
            return this.state.systemFields.concat(this.state.customFields)
        }
    }

    allowSelectingAllFields(fields) {
        if (fields.length < SELECTED_FIELDS_LIMIT) return true
        return false
    }

    getSelectedFields(fields) {
        const selectedFields = fields.filter((field) => {
            if (field.id && field.selected) return field

            if (this.state.selectedSystemFields.some((f) => f.fieldName === field.fieldName)) {
                return field
            }
        })

        return selectedFields.slice(0, SELECTED_FIELDS_LIMIT)
    }

    automate() {
        const drawerContent = <GroupAutomate groupName={this.state.group.groupName} GroupId={this.state.group.id} />
        this.props.dispatch(alterSiteDrawer(true, true, 'right', drawerContent, true, 500))
    }

    render() {
        const fields = this.getFields()
        const selectedFields = this.getSelectedFields(fields)

        var tags = this.state.tags
        var linkTags = this.state.linkTags

        var segments = JSON.parse(JSON.stringify(this.state.segmentsData))
        segments.unshift({
            name: 'All',
            subscriberCount: this.state.totalSubsInGroup,
            id: undefined,
            readOnly: false,
            label: i18n.t('subscribers:overview.all')
        })

        const telnoFields = this.state.customFields.filter((cf) => cf.fieldType === 'TELNO')

        return (
            <div>
                <Row className='middle-xs'>
                    <Column xs={12} sm={6} className='mar-b25'>
                        <TextInput
                            placeholder={i18n.t('subscribers:overview.searchPlaceholder')}
                            value={this.state.searchText}
                            onChange={this.changeSearchText}
                            clickToChangeClicked={this.goSearchText}
                            onKeyPress={this.searchKeyPress}
                            onEnterPress={() => {}}
                            className='no-marg'
                            iconLeft={
                                <Icons
                                    icon='magnifier'
                                    style={{ height: 16, width: 16 }}
                                    color='#2B2F41'
                                    onClick={() => {}}
                                />
                            }
                        />
                    </Column>

                    <Column xs={12} sm={6} className='end-xs mar-b25' style={{ display: 'flex' }}>
                        {!this.state.isBlacklist && (
                            <Button
                                className='mar-r10'
                                iconRight={<Icons icon='lightning' />}
                                onClick={this.automate.bind(this)}
                            >
                                Automate
                            </Button>
                        )}
                        {this.state.isBlacklist && (
                            <Button
                                onClick={() => this.props.history.push('/cp/groups/' + this.state.groupID + '/imports')}
                                className='mar-r10'
                            >
                                {i18n.t('subscribers:nav.imports')}
                            </Button>
                        )}
                        <Button
                            onClick={this.goAddSubsciberPage}
                            className='button-primary'
                            iconLeft={<Icons icon='plus' />}
                        >
                            {i18n.t('subscribers:nav.addSubscribers')}
                        </Button>
                    </Column>
                </Row>

                <Row className='hide-xs'>
                    <Column xs={12} sm={8} style={{ display: 'flex' }} className='mar-b25'>
                        {this.state.isBlacklist && (
                            <>
                                <Select
                                    inlineLabel='Denylist Filter'
                                    name='blackListFilter'
                                    data={[
                                        { label: 'All Contacts', value: 0 },
                                        { label: 'Unsubscribed', value: 1 },
                                        { label: 'Bounced', value: 2 }
                                    ]}
                                    value={this.state.blacklistFilter}
                                    onChange={(ev) => {
                                        this.setState({ blacklistFilter: ev.target.value }, this.tableDataGetter)
                                    }}
                                />
                            </>
                        )}

                        {!this.state.isBlacklist && (
                            <Select
                                outerClassName='mar-r10'
                                inlineLabel='Segment'
                                disabled={this.state.isLoading}
                                value={this.state.segmentId}
                                filter={true}
                                placeholderNoSelect='All'
                                autoWidth={true}
                                onChange={(e) => this.changeSegment(e.target.value)}
                                fixedHeightLarge={true}
                                data={segments.map((s) => {
                                    let tmpLabel = (
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div>{s.label}</div>
                                            {!!s.CapsuleId && (
                                                <SquareChip small={true} className={'square-chip-purple mar-l5'}>
                                                    Capsule
                                                </SquareChip>
                                            )}
                                            {s.id === 'SMS' && (
                                                <SquareChip small={true} className={'square-chip-stone mar-l5'}>
                                                    System
                                                </SquareChip>
                                            )}
                                        </div>
                                    )
                                    return {
                                        filter: s.label,
                                        label: tmpLabel,
                                        value: s.id,
                                        labelOverride: (
                                            <div style={{ display: 'flex' }}>
                                                <div>{s.label}</div>
                                                {s.id === this.state.segmentId &&
                                                this.state.totalGroupSubscribersFiltered !== undefined ? (
                                                    <div className='mar-l5'>
                                                        (
                                                        {NumberFunctions.formatNumber(
                                                            this.state.totalGroupSubscribersFiltered
                                                        )}
                                                        )
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        )
                                    }
                                })}
                            />
                        )}

                        {this.state.segmentId === 'SMS' && telnoFields.length > 1 && (
                            <Select
                                inlineLabel='SMS Field'
                                outerClassName='mar-r10'
                                autoWidth={true}
                                value={this.state.smsFieldId}
                                onChange={(e) =>
                                    this.setState({ smsFieldId: e.target.value }, () => this.tableDataGetter())
                                }
                                data={[{ label: 'Any Field', value: undefined }].concat(
                                    telnoFields.map((cf) => ({ label: cf.fieldDesc, value: cf.id }))
                                )}
                            />
                        )}

                        {!this.state.isBlacklist && (
                            <Select
                                value={this.state.status}
                                inlineLabel='Status'
                                outerClassName='mar-r10'
                                disabled={this.state.isLoading}
                                data={[
                                    {
                                        label: i18n.t('All'),
                                        value: ''
                                    },
                                    {
                                        label: i18n.t('Active'),
                                        value: 'active'
                                    },
                                    {
                                        label: i18n.t('In-Active'),
                                        value: 'in-active'
                                    },
                                    {
                                        label: i18n.t('Unsubscribed'),
                                        value: 'unsubscribed'
                                    },
                                    {
                                        label: i18n.t('Blacklisted'),
                                        value: 'blacklisted'
                                    },
                                    {
                                        label: i18n.t('Bounced'),
                                        value: 'bounce'
                                    }
                                ]}
                                onChange={(e) =>
                                    this.setState({ status: e.target.value }, () => this.tableDataGetter())
                                }
                            />
                        )}

                        {!this.state.isBlacklist && (
                            <Select
                                inlineLabel='Tags'
                                outerClassName='mar-r10'
                                placeholderNoSelect={i18n.t('All')}
                                disabled={this.state.isLoading}
                                multiple={true}
                                filter={true}
                                fixedHeightLarge={true}
                                autoWidth={true}
                                value={[
                                    ...this.state.selectedTags.map((tag) => '1_' + tag),
                                    ...this.state.selectedLinkTags.map((tag) => '2_' + tag)
                                ]}
                                onChange={this.selectTags}
                                data={tags
                                    .map((tag) => {
                                        let type = 'Contact Tags'
                                        if (tag.tagType === 3) type = 'SiteTracker Sources'
                                        return {
                                            label: tag.label,
                                            value: '1_' + tag.id,
                                            group: type
                                        }
                                    })
                                    .concat(
                                        linkTags.map((tag) => {
                                            return {
                                                label: tag.label,
                                                value: '2_' + tag.id,
                                                group: 'Link Tags'
                                            }
                                        })
                                    )}
                            />
                        )}
                    </Column>

                    <Column
                        xs={12}
                        sm={4}
                        className='hide-xs end-xs mar-b25'
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <Select
                            align='right'
                            outerClassName='mar-r5'
                            inlineLabel='Per Page'
                            value={this.state.pageSize}
                            data={[15, 50, 100, 250, 500]}
                            onChange={(e) => this.changePageSize(e.target.value)}
                        />
                        <ColumnSelect
                            data={[
                                ...this.state.systemFields.map((sf) => ({
                                    label: sf.fieldDesc,
                                    value: sf.fieldName,
                                    group: 'System Fields'
                                })),
                                ...this.state.customFields.map((cf) => ({
                                    label: cf.fieldDesc,
                                    value: cf.id,
                                    group: `Custom Fields (Max ${SELECTED_FIELDS_LIMIT})`,
                                    disabled:
                                        this.state.selectedFields.length >= SELECTED_FIELDS_LIMIT &&
                                        !this.state.selectedFields.some((f) => f === cf.id),
                                    iconRight:
                                        this.state.customFields.length > 100 ? undefined : cf.Application?.appLogoUri,
                                    iconRightTooltip:
                                        this.state.customFields.length > 100 ? undefined : cf.Application?.appName
                                }))
                            ]}
                            value={[...this.state.selectedFields, ...this.state.selectedSystemFields]}
                            onChange={this.changeSelectedFields}
                        />
                    </Column>

                    {this.state.loadingData == false &&
                        this.state.writeAccess == true &&
                        this.state.isBlacklist == false && (
                            <Column xs={12} className='end-xs mar-b25'>
                                <Button
                                    text={i18n.t('subscribers:index.bulk')}
                                    className='button mar-r10'
                                    onClick={this.bulkEdit}
                                />
                                <Button
                                    text={i18n.t('subscribers:index.export')}
                                    className='button'
                                    iconRight={<Icons icon='download' />}
                                    onClick={() => {
                                        this.props.history.push(`/cp/subscribers/export?gid=${this.state.groupID}`)
                                    }}
                                />
                            </Column>
                        )}
                </Row>

                <DataTable1
                    noResultsTxt={
                        PermissionChecker('subscribers', this.props.permissionStore.permissions, 'write') ? (
                            <a onClick={this.goAddSubsciberPage} className='hide-xs'>
                                {' '}
                                {i18n.t('subscribers:overview.noSubscribers')}{' '}
                            </a>
                        ) : (
                            i18n.t('subscribers:overview.noSubscribers2')
                        )
                    }
                    tableData={this.state.subscribers}
                    dataUpdater={this.changePage}
                    loadingData={this.state.loadingData}
                    sortedColumn={this.state.sortColumn}
                    sortedDirection={this.state.sortDirection}
                    isLoading={this.state.isLoading}
                    width='100%'
                    pageSize={this.state.pageSize}
                    hasCheckBoxes={
                        PermissionChecker('subscribers', this.props.permissionStore.permissions, 'write')
                            ? 'multi'
                            : false
                    }
                />

                <Row>
                    <Column xs={12} className='center-xs mar-t25'>
                        <PagingBlock
                            totalRows={this.state.totalGroupSubscribersFiltered}
                            pageSize={this.state.pageSize}
                            numberOfLinks='10'
                            currentPage={this.state.currentPage}
                            changePage={this.changePage}
                            text={i18n.t('page') + ':'}
                        />
                    </Column>
                </Row>

                <SnackBar
                    message={i18n.t('subscribers:index.resync')}
                    open={this.state.retry > 2}
                    autoCloseDuration={5000}
                    autoclose={true}
                    dismiss={() => this.setState({ retry: 0 })}
                />
            </div>
        )
    }
}
